export default __webpack_public_path__ + "static/former-geometriske-f4ae17499de58cd78b11298eb06238ed.png";